<p>© 2023 ABBYY Development, Inc.</p>
<section class="links">
  <a href="https://www.abbyy.com/privacy" target="_blank">Privacy Notice</a>
  <a href="https://www.abbyy.com/cookie-policy">Cookie Policy</a>
  <a href="javascript:Cookiebot.renew()">Cookie Management</a>
  <a href="{{settings.tos.url}}" target="_blank">Terms of Service</a>
</section>
